import * as React from 'react';
const UploadIcon = (props) => (
	<svg fill="none" viewBox="0 0 24 24" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="m9.32 6.5 2.56-2.56 2.56 2.56M11.88 14.18V4.01M4 12c0 4.42 3 8 8 8s8-3.58 8-8"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={2}
		/>
	</svg>
);
export default UploadIcon;
